var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJustice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3v4.47m2.25 7.34h7.7m-19.9 2.25h7.7m8.353-9.56l3.648 6.778c.213.395.3.854.215 1.294a3.94 3.94 0 01-7.728 0c-.086-.44.002-.899.215-1.294l3.65-6.778zm0 0A17.34 17.34 0 006.569 9.378l-.672.372m0 0l3.649 6.778c.213.395.3.854.215 1.294a3.939 3.939 0 01-7.73 0c-.085-.44.003-.899.216-1.294l3.65-6.778z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgJustice;